import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {SideBar, SideBarHead, SideList, SideListItemQuestion, SideListFolder} from 'app/components/SideBar/';
import QuestionForm from './QuestionForm';
import NewQuestion from './QuestionModel';
import { GetLanguageTexts, addMissingLanguageTexts } from './QuestionTextHelper';
import QuestionsHome from './components/QuestionsHome/QuestionsHomeComponent';
import QuestionService from "../../services/question.service";
import QuestionFolderService from "../../services/questionFolder.service";
import GetErrorMessage from '../../helpers/error-message';
import {ShowError, ShowSuccess} from "../../components/toast";
import { Loading } from '@ecosystem/ui-lib/core/components/Loading';
import {questionTypes } from '../../constants/question-types';
import {BlockUi} from 'app/components/Basics/';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import Modal from '../../components/Modal';
import InfiniteScroll from "react-infinite-scroll-component";
import NewFolderCreator from 'app/components/NewFolderCreator/NewFolderCreatorComponent';
import './QuestionComponent.scss';

class Question extends Component {	
	constructor (props) {
		super(props);
		this.state = {
			search: '',
			infiniteScrollPage: 1,
			infiniteScrollHasMore: true,
			questions: [],
			folders: [],
			foldersOriginal: [],
			loading: false,
			errorMessage: null,
			selectedQuestion: null,
			originalSelectedQuestion: null,
			searchedTerm: '',
			uiBlocked: false,
			editorOpen: false,
			shouldIncludeArchived: false,
			currentFolderId: null,
			currentFolderName: null,
			successMessageFolder: null
		}
	}

	setSearchState(event) {    
		var value = event.target.value;    
		this.setState({search: value});
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.search !== prevState.search) {			
			this.queryQuestions(this.state.search)
		}

		if (this.state.editorOpen !== prevState.editorOpen) {
			if (this.state.editorOpen) {
			 //retrigger selected question if editor was closed        
				this.setState({selectedQuestion: this.state.selectedQuestion});
			}
		}
	}

	componentDidMount() {
		this.queryQuestionFolders('');
		this.queryQuestions('');
		this.setState({defaultLanguageCode: this.getDefaultLanguageCode()});
		
		this.unblock = this.props.history.block((tx) => {
			if (this.didSelectedQuestionChange()) {
				this.showLoseChangeConfirmationModal(() => {
					this.unblock();
					this.props.history.push(tx.pathname + tx.search);
				});
				return false;
			}
		});
	}

	componentWillUnmount() {
		if (this.unblock) {
			this.unblock();
		}
	}

	getDefaultLanguageCode() {
		var defaultLanguage = this.props.languages.find(l => l.isDefault === true);	
		if (defaultLanguage === undefined) 	defaultLanguage = this.props.languages[0];		
		return defaultLanguage.code;
	}

	openEditor() {
		this.setState({ editorOpen: true });
	}

	closeEditorButtonOnClick() {
		if (this.shouldLosePossibleChangesOnEditor(this.closeEditor)) {
				this.closeEditor();
		}
	}

	closeEditor() {
		this.setState({ editorOpen: false });
		this.setSelectedItem(null);
	}
		
	queryQuestions(term, clearList) {		
		if (this.state.loading) return;		

		var shouldIncludeArchived = this.state.shouldIncludeArchived;
		var page = this.state.infiniteScrollPage;
		this.setState({ loading: true });
		if (term !== this.state.searchedTerm || clearList) {
			page = 1;
			this.setState({ questions: [], infiniteScrollPage: page });
		}		
		this.toggleUiBlock(true);		
		QuestionService.findQuestionsPaged(term, false, "", page, shouldIncludeArchived, [], true, this.state.currentFolderId)
			.then(response => {          
				var questions = this.state.questions;
				questions.push(...response.data.questions);
				this.setState({ 
					questions: questions,
					infiniteScrollPage: page + 1,
					infiniteScrollHasMore: response.data.hasMoreQuestions,
					loading: false,
					searchedTerm: term
				});
				this.toggleUiBlock(false);
				return response;          
			})
			.catch(error => {			  
				let errorMessage = GetErrorMessage(error);
				console.log("errorMessage on catch");
				console.log(errorMessage);
				this.toggleUiBlock(false);
				this.setState({ loading: false, errorMessage: errorMessage});            
			})
	}	

	queryQuestionFolders(term) {
		this.setState({ loading: true });		
		QuestionFolderService.find(term)
			.then(response => {
				var folders = response.data;				
				this.setState({
					folders: folders,
					foldersOriginal: cloneDeep(folders),					
					loading: false			
				});
				return response;          
			})
			.catch(error => {			  
				let errorMessage = GetErrorMessage(error);
				console.log("errorMessage on catch");
				console.log(errorMessage);
				this.setState({ loading: false, errorMessage: errorMessage});            
			})
	}

	getQuestionById(id) {		
		this.toggleUiBlock(true)
		QuestionService.getQuestionById(id)
			.then(response => {
				this.updateSelectedQuestion(response.data);
				this.updateSavedQuestionOnList(response.data);				
				this.toggleUiBlock(false)
				return response;          
			})
			.catch(error => {			  
				let errorMessage = GetErrorMessage(error);
				console.log("errorMessage on catch");
				console.log(errorMessage);
				this.setState({ errorMessage: errorMessage});    
				this.toggleUiBlock(false)        
			})
	}
	
	getQuestionType(questionTypeCode) {
		var questionType = questionTypes.find(q => q.value === questionTypeCode);
		if (questionType === undefined) return "invalid_question_type";
		return questionType.label;
	}

	getSelectedItem(selectedQuestionId) {
		this.openEditor();
		if (this.shouldLosePossibleChangesOnEditor(() => this.getQuestionById(selectedQuestionId))) {			
			this.getQuestionById(selectedQuestionId)			
		}		
	}  

	setSelectedItem(selectedQuestion) {
		this.setState({selectedQuestion: selectedQuestion});
	}

	shouldLosePossibleChangesOnEditor(callbackAfterLoseChangesConfirmation) {		
		if (this.didSelectedQuestionChange()) {
			this.showLoseChangeConfirmationModal(callbackAfterLoseChangesConfirmation);
			return false;	
		}
		else {	
			return true;
		}	
	}

	didSelectedQuestionChange() {
		let selectedQuestion = this.state.selectedQuestion;
		if (!selectedQuestion) return false;
		let questionsAreEquals = isEqual(selectedQuestion, this.state.originalSelectedQuestion);
		return !questionsAreEquals;
	}

	showLoseChangeConfirmationModal(callbackAfterLoseChangesConfirmation) {
		this.setState({ 
			loseChangesModalText: `There are unsaved changes to the question with code '${this.state.selectedQuestion.code}'. Are you sure do you want to leave without saving?`,
			callbackAfterLoseChangesConfirmation: callbackAfterLoseChangesConfirmation
		});
	}

	confirmLoseChangesModalHandler() {
		let questions = this.rollbackToOriginalQuestion(this.state.questions, this.state.originalSelectedQuestion);
		this.setState({questions: questions	}, this.state.callbackAfterLoseChangesConfirmation);
		this.hideLoseChangesModal();
	}

	rollbackToOriginalQuestion(list, originalSelectedItem) {
		const index = list.findIndex(item => item.id === this.state.selectedQuestion.id);	
		list[index] = originalSelectedItem;
		return list;
	}

	hideLoseChangesModal() {
		this.setState({loseChangesModalText: ''})
	}

	isItemSelected(questionId) {    
		if (this.state && this.state.selectedQuestion && 
			this.state.selectedQuestion.id === questionId) {
			return true;
		} else {
			return false;
		}
	}

	toggleUiBlock(blockUi) {
		this.setState({uiBlocked: blockUi});
	} 

	addNewQuestionHandler = event => {
		if (this.shouldLosePossibleChangesOnEditor(() => this.addNewQuestion())) {
			this.addNewQuestion()
		}    
		event.preventDefault();
	}

	addNewQuestion() {
		const newQuestion = NewQuestion(this.state.defaultLanguageCode);
		if (this.state.currentFolderId) {
			newQuestion.folderId = this.state.currentFolderId;
		}
		this.setState({selectedQuestion: newQuestion});
		this.openEditor();
	}

	removeDeletedQuestion(questionId) {    
		const questions = this.state.questions.filter(q => q.id !== questionId);
		this.setState({ questions: questions });    
	}

	updateSavedQuestionOnList(selectedQuestion) {    
		let questions = [...this.updateQuestionsList(this.state.questions, selectedQuestion)];    
		this.setState({questions: []});
		this.setState({
			questions: questions,	
			selectedQuestion: selectedQuestion, 
			originalSelectedQuestion: cloneDeep(selectedQuestion) 
		});    
	}

	updateQuestionsList(list, selectedQuestion) {
		var index = list.findIndex(q => q.id === selectedQuestion.id);    
		if (index === -1) {
			list.push(selectedQuestion);      
		}
		else {
			list[index] = selectedQuestion;      
		}
		return list;
	}

	updateSelectedQuestion(selectedQuestion) {		
		this.setState({selectedQuestion: selectedQuestion})
	}	

	includeArchivedHandler(shouldIncludeArchived) {		
		this.setState({shouldIncludeArchived: shouldIncludeArchived}, 
			function() {
				this.queryQuestions(this.state.search, true);
			});			
	}
	
	navigateToFolder(folderId, folderName) {		
		this.setState(
			{
				currentFolderId: folderId,
				currentFolderName: folderName,
				infiniteScrollPage: 1,
				questions: []
			}, () => { this.queryQuestions(this.state.search, true);}
		);
	}

	navigateToRoot() {
		this.setState({
			currentFolderId: null,
			currentFolderName: null,
			infiniteScrollPage: 1,
			questions: []
			}, () => { this.queryQuestions(this.state.search, true);}
		);
	}

	createFolder(folder) {
		this.toggleUiBlock(true)
		QuestionFolderService.createFolder(folder)
			.then(response => {                    
				const newFolder = response.data;
				var folders = this.state.folders;
				folders.push(newFolder)
				this.setState({folders: folders})			
				this.toggleUiBlock(false)
				this.setState({successMessageFolder: `The folder ${folder.name} was created successfully` });
				
			})
			.catch(error => {
				let errorMessage = GetErrorMessage(error);
				console.log("errorMessage on catch");
				console.log(errorMessage);
				this.setState({ errorMessage: errorMessage});
				this.toggleUiBlock(false)	
			});
	}

	updateFolder(folder) {		
		this.toggleUiBlock(true)
		QuestionFolderService.updateFolder(folder)
			.then(response => {			
				this.toggleUiBlock(false);
				this.setState({successMessageFolder: `The folder ${folder.name} was saved successfully` });			
			})
			.catch(error => {
				this.rollbackFolderNameChange(folder);
				let errorMessage = GetErrorMessage(error);
				console.log("errorMessage on catch");
				console.log(errorMessage);	
				this.setState({ errorMessage: errorMessage});		
				this.toggleUiBlock(false)	
			});
	}

	rollbackFolderNameChange(folder) {
		var originalFolder = cloneDeep(this.state.foldersOriginal.find(f=>f.id === folder.id));
		var folders = this.state.folders;
		var index = this.state.folders.findIndex(({ id }) => id === folder.id);
		folders[index].name = originalFolder.name;
	}

	deleteFolder(folder)  {		
		this.setState({ 
			deleteFolderModalText: `Are you sure you want to delete the folder '${folder.name}'?`,
			folderToDelete: folder
		});
	}

	folderContainQuestions(folder) {
		var result = this.state.questions.find(q => q.folderId === folder.id);
		return result !== undefined;
	}

	confirmDeleteFolder() {		
		this.hideDeleteFolderModal();
		if (this.folderContainQuestions(this.state.folderToDelete)) {
			this.setState({
				deleteFolderContentsModalText: `This folder contains questions. Deleting it will also delete ALL questions inside it. Are you sure you want to proceed?`
			});
			return;
		}
		this.executeDeleteFolder();
	}

	confirmDeleteFolderWithContents() {
		this.hideDeleteFolderContentsModal();
		this.executeDeleteFolder();
	}

	hideDeleteFolderContentsModal() {
		this.setState({deleteFolderContentsModalText: ''})
	}

	executeDeleteFolder() {
		this.toggleUiBlock(true);
		let _this = this;   
		QuestionFolderService.deleteFolder(this.state.folderToDelete)
		.then(response => {
			this.toggleUiBlock(false);
			this.setState({successMessageFolder: 'The folder was deleted successfully' });
			let questions = this.state.questions.filter(q => q.folderId !== _this.state.folderToDelete.id);
			let folders = this.state.folders;
			folders = folders.filter(function(folder) {
				return folder.id !== _this.state.folderToDelete.id;
			});
			this.setState({folders: folders, questions: questions});
			this.navigateToRoot();
		})
		.catch(error => {
			let errorMessage = GetErrorMessage(error);
			console.log("errorMessage on catch");
			console.log(errorMessage);
			this.toggleUiBlock(false);
			this.setState({ errorMessage: errorMessage});
		})
		.finally(function() {
			_this.setState({folderToDelete: null})
		});		
	}

	hideDeleteFolderModal() {
		this.setState({deleteFolderModalText: ''})
	}

	newFolder(newFolderText) {
		var folder = {
			id: null,
			name: newFolderText			
		}
		return folder;
	}

	saveNewFolder(newFolderText) {
		var folder = this.newFolder(newFolderText);
		this.createFolder(folder);
	}

	render() {
		return (
			<BlockUi blocking={this.state.uiBlocked}>
				<main className="app-body questions">                   
					<SideBar
						footerContent={
							this.props.userPermissions?.CanChangeQuestion ? (
								<NewFolderCreator
									canChangeData={this.props.userPermissions?.CanChangeQuestion}
									saveNewFolderHandler={this.saveNewFolder.bind(this)}
								/>
							) : null
						}
					>
						<SideBarHead 
							showIncludeArchive={true} 
							includeArchivedHandler={this.includeArchivedHandler.bind(this)} 
							canChangeData={this.props.userPermissions?.CanChangeQuestion} 
							tagName="SideBarHead" 
							headline="Questions" 
							addButton 
							addButtonLabel="Question" 
							addButtonCallBack={this.addNewQuestionHandler.bind(this)}
							onChange={this.setSearchState.bind(this)}
						/>                  
						<SideList tagName="SideList">							
							{this.state.currentFolderName && (
								<div className="folder-breadcrumb">
									<button className="breadcrumb-home" onClick={() => this.navigateToRoot()}>
										Home
									</button>
									{" > "} 
									<span className="current-folder">{this.state.currentFolderName}</span>
								</div>
							)}							
							
							{!this.state.currentFolderName 
								&& !this.state.loading 
								&& this.state.search === '' 
								&& this.state.folders								
								.map(folder => (
									<SideListFolder 
										isFlatList={true}
										key={folder.id}
										canChangeData={this.props.userPermissions?.CanChangeQuestion} 
										folder={folder} 
										updateFolder={this.updateFolder.bind(this)} 
										deleteFolder={this.deleteFolder.bind(this)}
										onFolderClick={this.navigateToFolder.bind(this, folder.id, folder.name)}
									>
										{/* Folders are clickable but don't contain items in this implementation */}
									</SideListFolder>
								))
							}

							{!this.state.currentFolderName && (<hr className='side-list-line'/>)}
							
							<InfiniteScroll
								dataLength={this.state.questions.length}
								next={() => this.queryQuestions(this.state.search)}
								hasMore={this.state.infiniteScrollHasMore}
								loader={<Loading active={true}></Loading>}
								scrollableTarget="SideBarScrollableDiv">
								{this.state.questions.map(q => 
									<div key={q.code}>
										<SideListItemQuestion 
											key={q.code}
											qid={q.id}
											qcode={q.code}
											qtype={this.getQuestionType(q.questionType)}
											itemStatus="In-Use"                          
											getSelectedItem={this.getSelectedItem.bind(this)}  
											isItemSelected={this.isItemSelected(q.id)}
											isItemArchived={q.inArchive === 1}             
										>
											{GetLanguageTexts(q.texts, this.getDefaultLanguageCode()).textPlain}
										</SideListItemQuestion>
									</div>
								)}
							</InfiniteScroll>
							
							{/* {this.props.userPermissions?.CanChangeQuestion && (
								<NewFolderCreator 
									canChangeData={this.props.userPermissions?.CanChangeQuestion}
									saveNewFolderHandler={this.saveNewFolder.bind(this)} />
							)} */}
						</SideList>
					</SideBar>
					<div className="app-content scrollbox">
					{this.state.editorOpen && ( 
						<QuestionForm 
							openEditor={this.openEditor.bind(this)} 
							didSelectedQuestionChange={this.didSelectedQuestionChange.bind(this)} 
							closeEditorButtonOnClick={this.closeEditorButtonOnClick.bind(this)}					  
							closeEditor={this.closeEditor.bind(this)}
							removeDeletedQuestion={this.removeDeletedQuestion.bind(this)} 
							toggleUiBlock={this.toggleUiBlock.bind(this)} 
							selectedQuestion={this.state.selectedQuestion}
							updateSelectedQuestion={this.updateSelectedQuestion.bind(this)}
							updateSavedQuestionOnList={this.updateSavedQuestionOnList.bind(this)}
							canChangeData={this.props.userPermissions?.CanChangeQuestion}  
							canChangeDemoQuestion={this.props.userPermissions?.CanChangeDemoQuestion}
							canChangeHoneypotQuestion={this.props.userPermissions?.CanChangeHoneypotQuestion}
							folders={this.state.folders}
							languages={this.props.languages}
							defaultLanguageCode={this.state.defaultLanguageCode}								
						/> 
					)}
					{!this.state.editorOpen && ( <QuestionsHome></QuestionsHome>)}
					</div>
				
					{this.state.deleteFolderModalText && (<Modal size="small" content={this.state.deleteFolderModalText} confirmModalHandler={this.confirmDeleteFolder.bind(this)} cancelModalHandler={this.hideDeleteFolderModal.bind(this)}/>)}
					{this.state.deleteFolderContentsModalText && (<Modal size="small" content={this.state.deleteFolderContentsModalText} confirmModalHandler={this.confirmDeleteFolderWithContents.bind(this)} cancelModalHandler={this.hideDeleteFolderContentsModal.bind(this)}/>)}
					{this.state.successMessageFolder && (<ShowSuccess clearMessage={() => this.setState({successMessageFolder: ''})} message={this.state.successMessageFolder}/>)}
					{this.state.errorMessage && (<ShowError clearErrorMessage={() => this.setState({errorMessage: ''})} errorMessage={this.state.errorMessage}/>)}
					{this.state.loseChangesModalText && (<Modal size="small" content={this.state.loseChangesModalText} confirmModalHandler={this.confirmLoseChangesModalHandler.bind(this)} cancelModalHandler={this.hideLoseChangesModal.bind(this)}/>)}
				</main>
			</BlockUi>
		);
	}
}

export default withRouter(Question);